import { Component, inject } from '@angular/core';
import { DesyCommonsModule, DesyNavModule } from 'desy-angular';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-header',
  imports: [DesyNavModule, DesyCommonsModule, TitleCasePipe],
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  protected readonly authenticationService = inject(AuthenticationService);

  protected readonly AuthenticationService = AuthenticationService;
}
